/***** body addclass *****/
  $(document).ready(function(){
    var loc = location.pathname.split('/');
    var locclr = loc.filter(Boolean);
    var dirName = locclr[locclr.length -1];
    if ( locclr.length === 0 || dirName === 'en' || dirName === 'fr' || dirName === 'ko' || dirName === 'zh' ){
        $('body').addClass('top');
    } else {
        $('body').addClass(dirName);
    }

    /* anyclass */ 
      if ( dirName === 'shoppingguide-commmonsmart' || dirName === 'users-guide' || dirName === 'pages-users-guide' || dirName === 'faq' || dirName === 'contact' ){
        $('body').addClass('about');
      }
      if ( dirName === 'refund-policy' || dirName === 'shipping-policy' || dirName === 'terms-of-service' || dirName === 'privacy-policy' || dirName === 'ccpa-opt-out' || dirName === 'legal-notice' ){
        $('body').addClass('about policy');
      }
    /* /anyclass */

  });

  $(document).ready(function(){
    $('div.mobile-nav__has-sublist').addClass('mobile-nav--expanded');
  });
/***** /body addclass *****/





/***** div addclass *****/
  $(document).ready(function(){
    $('.collection_wrapper_child').each(function() {
      $(this).parent('div').addClass('collection_wrapper');
    });

    $('.homepage-sections-wrapper').each(function() {
      $(this).parent('div').addClass('collection_wrapper');
    });
  });
/***** /div addclass *****/





/***** products scroll hide *****/
// $(document).ready(function() {
//     if (window.matchMedia("(max-width: 768px)").matches) {
//       var pageTop = $('body.template-product .breadcrumb, body.template-product .site-nav--mobile, body.template-product ul.site-header__links li:nth-of-type(2)');
//       var pageTopps = $('body.template-product .breadcrumb, body.template-product .site-nav--mobile, body.template-product ul.site-header__links li:nth-of-type(2)').offset();
//       pageTop.hide();
//       $(window).on("scroll touchmove", function () {
//         pageTop.stop();
//         pageTop.fadeOut();
//         if ($(this).scrollTop() > 300) {
//           pageTop.stop();
//           pageTop.hide().delay(300).fadeIn('fast');
//         }
//       });
//     }
//   });
/***** /products scroll hide *****/

/***** accordion *****/
  document.addEventListener('click', (event) => {
    let title = event.target.closest('.acdn_btn');
    if( title ) {
      let item = title.closest('.acdn');
      let panel = item.querySelector('.acdn_btn');
      panel.classList.toggle('acdn_show');
    }
  });
/***** /accordion *****/

/***** TOP スクロール *****/
// (function () {
//   function initCollectionScroll() {
//     const arrow = document.querySelector('.collection-scroll-arrow');
//     const track = document.querySelector('.homepage-product-grid-wrapper');

//     if (!arrow || !track) return;

//     arrow.addEventListener('click', () => {
//       track.scrollBy({
//         left: track.clientWidth * 0.9,
//         behavior: 'smooth'
//       });
//     });
//   }

//   // Shopify Section 再描画対応
//   document.addEventListener('DOMContentLoaded', initCollectionScroll);
//   document.addEventListener('shopify:section:load', initCollectionScroll);
// })();

(function () {
  function initCollectionScroll() {
    document
      .querySelectorAll('.homepage-sections-wrapper')
      .forEach(section => {

        const arrow = section.querySelector('.collection-scroll-arrow');
        const track = section.querySelector('.homepage-product-grid-wrapper');

        if (!arrow || !track) return;

        // 二重バインド防止
        if (arrow.dataset.bound === "true") return;
        arrow.dataset.bound = "true";

        arrow.addEventListener('click', () => {
          track.scrollBy({
            left: track.clientWidth * 0.9,
            behavior: 'smooth'
          });
        });
      });
  }

  document.addEventListener('DOMContentLoaded', initCollectionScroll);
  document.addEventListener('shopify:section:load', initCollectionScroll);
})();

/***** scroll side cart button *****/
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.side-cart-btn');

  if (btn) {
    var target = document.querySelector('#quantity');

    if (target) {
      var btnRect = btn.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();

      var offset = targetRect.top - btnRect.top;

      var scrollPosition =
        window.pageYOffset + offset - 20; // ← ここ追加

      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
    }
  }
});
/***** /scroll side cart button *****/


//var swiper = new Swiper(".mySwiper", {
//     slidesPerView: 4,
//     centeredSlides: true,
//      spaceBetween: 30,
//      grabCursor: true,
//      pagination: {
//        el: ".swiper-pagination",
//        clickable: true,
//      },
//    });




// if (window.matchMedia('(max-width: 767px)').matches) {
// 	var swiper = new Swiper('.mySwiper', {
// 	slidesPerView: '2.1',
// 	centeredSlides: true,
// 	spaceBetween: 20,
//   clickable: true,
//       navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//       }
//     });
// } else if (window.matchMedia('(min-width:768px)').matches) {
// 	var swiper = new Swiper('.mySwiper', {
// 	slidesPerView: '4.2',
// //	centeredSlides: true,
// 	spaceBetween: 30,
//   clickable: true,
//   loop: true,
//       navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//       }
//     });
// }


document.querySelectorAll('.mySwiper').forEach(function(el){

  let slidesPerView = window.matchMedia('(max-width: 767px)').matches ? 2.1 : 4.2;
  let spaceBetween  = window.matchMedia('(max-width: 767px)').matches ? 20 : 30;

  new Swiper(el, {
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    loop: window.matchMedia('(min-width:768px)').matches,

    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    }
  });

});

document.querySelectorAll('.reco-Swiper').forEach(function(el){

  let slidesPerView = window.matchMedia('(max-width: 767px)').matches ? 2.1 : 3.5;
  let spaceBetween  = window.matchMedia('(max-width: 767px)').matches ? 20 : 30;

  new Swiper(el, {
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    loop: window.matchMedia('(min-width:768px)').matches,

    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    }
  });

});
